import { useMemo } from 'react';
import randomId from './randomId';

const useId = () => useMemo(() => randomId(6), []);

export default useId;
